/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(data) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetReviewDecision: {
        $xmlns: 'http://dobs.pa.gov/nd/review/bpm/1.0',
        ObjectID: data.objectId,
        ObjectTypeID: data.objectTypeId
      }
    },
    blueprint: {
      id: '$..ID',
      objectId: '$..ObjectID',
      objectTypeId: '$..ObjectTypeID',
      reviewDecisionId: '$..ReviewDecisionID',
      decisionReason: '$..DecisionReason',
      decisionName: '$..DecisionName',
      decisionRole: '$..DecisionRole',
      decisionDate: '$..DecisionDate',
      completedByUserId: '$..CompletedByUserID',
      createdDate: '$..CreatedDate',
      modifiedDate: '$..ModifiedDate',
      modifiedBy: '$..ModifiedBy'
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      response.createdDate = moment(response.createdDate, moment.ISO_8601).format('MM/DD/YYYY hh:mm a');
      response.modifiedDate = moment(response.modifiedDate, moment.ISO_8601).format('MM/DD/YYYY hh:mm a');
      if (response.decisionDate) {
        response.decisionDate = moment(response.decisionDate, moment.ISO_8601).format('MM/DD/YYYY hh:mm a');
      }
      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
